export const INVENTORY_ERRORS_CODES = {
  VAL_0006: 'Digite apenas números e letras no campo de código do produto.',
  VAL_0007: 'Esse código já está sendo usado em outro produto.',
}

export const CAMPAING_ENROLLMENT_ERROR_CODES = {
  BUSS_0031: 'BUSS_0031',
  BUSS_0032: 'BUSS_0032',
  BUSS_0033: 'BUSS_0033',
}
